const warningDueStatement = {
  'warningDueStatement.label': 'Total',
  'warningDueStatement.dueDays': 'Payment overdue',
};

export default warningDueStatement;
